/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { sharedListPagesTabelStyle } from "@monsma/App/WidgetExtensions/MyAccount/MyAccountListPagesExtension";
import { orderHistoryTableStyles } from "@monsma/Overrides/Widgets/OrderHistory/OrderHistoryTable";
import { css } from "styled-components";

orderHistoryTableStyles.container = sharedListPagesTabelStyle.container;

orderHistoryTableStyles.orderTotalHeader = {
    tight: true,
};

orderHistoryTableStyles.orderTotalCells = {};

orderHistoryTableStyles.reorderButton = {
    variant: "primary",
    sizeVariant: "small",
};

orderHistoryTableStyles.noResultsContainer = sharedListPagesTabelStyle.noResultsContainer;

orderHistoryTableStyles.reorderButtonSpinner = {
    size: 22,
    css: css`
        margin-left: auto;
        margin-right: auto;
        display: block;
        min-height: 36px;
    `,
};
